module.exports = __webpack_public_path__ + "assets/BngMUXZYTXPIvIBgJJSb6ufC5qW54A-b90591.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/BngMUXZYTXPIvIBgJJSb6ufC5qW54A.woff2
// module id = 871
// module chunks = 2